import { UserListPage } from "newui/features/Auth/components/User/UserListPage";
import { useHasRbacV2 } from "hooks/featureFlags";
import { UserAssignmentTable } from "./UserAssignmentTable";

interface AccountUsersRouteProps {
	// reach-router injects `path` when this is used as a <Router> child; unused here.
	path?: string;
}

/**
 * FF-W3-6: single mount point for account-settings/users.
 *
 * EnableRbacV2 ON  → the RBAC v2 UserAssignmentTable (roles/scopes/flags) page.
 * EnableRbacV2 OFF → the legacy UserListPage, rendered byte-identically (no-op
 *   fallback — this component adds no wrapper/props in the off path).
 */
export const AccountUsersRoute = ({ path: _path }: AccountUsersRouteProps) => {
	const hasRbacV2 = useHasRbacV2();

	if (!hasRbacV2) {
		return <UserListPage />;
	}

	return (
		<div
			className="rounded-lg bg-white shadow-sm border border-gray-200 p-4"
			data-testid="rbac-users-page"
		>
			<UserAssignmentTable />
		</div>
	);
};
